export const goBack = () => {
  window.history.back();
};
